enum PRISMIC_TAGS {
  CONFIRMATION_TAG = 'Confirmation Page',
}

enum CHANGE_FREQUENCY {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

enum INPUT_TYPES {
  dropdown = 'dropdown',
  textarea = 'textarea',
  text = 'text',
  email = 'email',
  phone = 'tel',
}

export { PRISMIC_TAGS, CHANGE_FREQUENCY, INPUT_TYPES };
